import {Component, Input} from '@angular/core';
import {AssetUploadProperty} from "../../../upload/upload.model";
import {MatChipGrid, MatChipInput, MatChipInputEvent, MatChipRemove, MatChipRow} from "@angular/material/chips";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatCheckbox} from "@angular/material/checkbox";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {TranslatePipe} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatInput} from "@angular/material/input";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
    selector: 'app-asset-detail-formfield',
    imports: [
        MatLabel,
        MatFormField,
        MatCheckbox,
        MatChipGrid,
        MatChipRow,
        MatIcon,
        MatChipInput,
        MatChipRemove,
        ReactiveFormsModule,
        TranslatePipe,
        MatChipInput,
        MatChipRow,
        MatIcon,
        MatSelect,
        MatOption,
        MatInput,
        MatTooltip
    ],
    templateUrl: './asset-detail-formfield.component.html',
    styleUrl: './asset-detail-formfield.component.scss'
})
export class AssetDetailFormfieldComponent {

    @Input({required: true}) prop!: AssetUploadProperty;
    @Input({required: true}) control!: FormControl

    getChipEntries(): string[] {
        return this.control.value || [];
    }

    removeChipEntry(entry: string) {
        let entries = this.getChipEntries();
        let newEntries = entries.filter(e => e !== entry);
        this.control.setValue(newEntries);
    }

    addChipEntry($event: MatChipInputEvent) {
        let value = $event.value;
        if (!value) {
            return;
        }
        if (this.prop.validation?.itemValidation?.maxLength && value.length > this.prop.validation?.itemValidation?.maxLength) {
            // TODO error?
            return;
        }
        let entries = this.getChipEntries();
        let values = value.split(',').map(s => s.trim()).filter(s => s.length > 0);
        entries.push(...values);
        this.control.setValue(entries);
        $event.chipInput!.clear();
    }

    handleBlur($event: FocusEvent) {
        let target = $event.target as HTMLInputElement;
        let value = target.value;
        if (!value) {
            return;
        }
        let entries = this.getChipEntries();
        let values = value.split(',').map(s => s.trim()).filter(s => s.length > 0);
        entries.push(...values);
        this.control.setValue(entries);
        target.value = '';
    }
}
